import type { ReactNode } from "react";
import { NavigationScrollManager } from "./NavigationScrollManager";
import { SkipLink } from "./SkipLink";
import { SiteFooter } from "./SiteFooter";
import { SiteHeader } from "./SiteHeader";

export function SiteLayout({ children }: { children: ReactNode }) {
  return (
    <div className="site-shell">
      <NavigationScrollManager />
      <SkipLink />
      <SiteHeader />
      <main id="main-content">{children}</main>
      <SiteFooter />
    </div>
  );
}
